import { useNavigate } from 'react-router';
import { useAtom } from 'jotai';
import { userRecordAtom } from '../../../../shared/state/atoms';
import { PATH_DASHBOARD } from '../../../../shared/routes/paths';
import { useToast } from '../../../../shared/hooks';
import { USER_ROLES } from '../../../../shared/utils/roles';
import { useSchoolAdminService, useAuthService } from '../../../../shared/services';

function useLoginForm() {
  const navigate = useNavigate();
  const [, setUserRecord] = useAtom(userRecordAtom);
  const { signIn } = useAuthService();
  const { getSchoolAdmin, getParent, getTeacher } = useSchoolAdminService();
  const { showError } = useToast();
  const { ROLE_ADMIN, ROLE_TECAHER } = USER_ROLES;

  const login = async (email, password) => {
    try {
      const res = await signIn(email, password);
      const { uid } = res.user;

      const user = await getSchoolAdmin(uid);
      if (user) {
        setUserRecord({
          ...user,
          id: uid,
          role: ROLE_ADMIN,
        });
      } else {
        const teacher = await getTeacher(uid);
        if (teacher) {
          setUserRecord({
            ...teacher,
            id: uid,
            role: ROLE_TECAHER,
          });
        } else {
          const parent = await getParent(uid);
          if (parent) {
            showError('Parents cannot login to the Hula school platform.');
            return;
          }
        }
      }

      navigate(PATH_DASHBOARD.general.app, { replace: true });
    } catch (error) {
      showError('The email or password that you have entered is incorrect.');
    }
  };

  return {
    login,
  };
}

export default useLoginForm;
